import React, { useState, useEffect } from 'react';


// import data
import { projectsData } from '../data';
import { projectsNav } from '../data';
import { ChevronDownIcon } from '@heroicons/react/outline';

// import components
import Project from './Project';

const Projects = () => {
  const [item, setItem] = useState({ name: 'all' });
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState(0);
  const [limit, setLimit] = useState(6);
  const [disabled, setDisabled] = useState(false)
  

  useEffect(() => {
    // get projects based on item
    if (item.name === 'all') {
      setProjects(projectsData);
    } else {
      const newProjects = projectsData.filter((project) => {
        return project.category.toLowerCase() === item.name;
      });
      setProjects(newProjects);
    }
  }, [item]);

  const handleClick = (e, index) => {
    setItem({ name: e.target.textContent.toLowerCase() });
    setActive(index);
  };

 const handleLimit = () => {
  setLimit(18)
  setDisabled(true)
 }

  return (
    <div>
      {/* projects nav */}
      <nav className='mb-12 max-w-xl mx-auto'>
        <ul className='flex flex-col md:flex-row justify-evenly items-center text-white'>
          {projectsNav.map((item, index) => {
            return (
              <li
                onClick={(e) => {
                  handleClick(e, index);
                }}
                className={`${
                  active === index ? 'active' : ''
                } cursor-pointer capitalize m-4`}
                key={index}
              >
                {item.name}
              </li>
            );
          })}
        </ul>
      </nav>
      
      {/* projects */}
      <section className='grid gap-y-12 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-8'>
         
        { projects.slice(0, limit).map((item) => {
          return <Project item={item} key={item.id} />;
        })}
       
      </section>

      {/* More button */}
      <div className='flex justify-center mt-9 text-white'>
      <button
      disabled={disabled}
       onClick={handleLimit}
        className={` "btn flex items-center justify-around gap-2 px-4 rounded-md btn-md bg-gradient-to-r from-gray-600  to-gray-500 hover:text-lg md:btn-lg transition-all" ${disabled && "cursor-not-allowed invisible"}`}>
          Περισσότερες
         <ChevronDownIcon className='w-8 h-6'/>
          </button>
      </div>
    </div>
  );
};

export default Projects;
